/**
 * UX helpery — UX vrstva D.
 */

/**
 * Vrátí true, pokud byla položka vytvořena/přijata/odeslána v posledních 24 hodinách.
 * Používá se pro vizuální highlight "Nová" v list view.
 */
export function isRecent(timestamp, hours = 24) {
  if (!timestamp) return false;
  const t = new Date(timestamp).getTime();
  if (Number.isNaN(t)) return false;
  return Date.now() - t < hours * 60 * 60 * 1000;
}

/**
 * Lidsky čitelný relativní čas v češtině: "před 5 min", "před 2 h", "včera",
 * starší 7 dnů → konkrétní datum.
 */
export function formatRelative(timestamp) {
  if (!timestamp) return '';
  const t = new Date(timestamp).getTime();
  if (Number.isNaN(t)) return '';
  const diffMs = Date.now() - t;
  const min = Math.floor(diffMs / 60000);
  if (min < 1) return 'právě teď';
  if (min < 60) return `před ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `před ${h} h`;
  const d = Math.floor(h / 24);
  if (d === 1) return 'včera';
  if (d < 7) return `před ${d} dny`;
  return new Date(timestamp).toLocaleDateString('cs-CZ');
}
